export const SPRAYED_ENTITIES_BY_DATE_LOAD_REQUESTED =
    'SPRAYED_ENTITIES_BY_DATE_LOAD_REQUESTED';
export const SPRAYED_ENTITIES_BY_DATE_LOAD_SUCCEEDED =
    'SPRAYED_ENTITIES_BY_DATE_LOAD_SUCCEEDED';
export const SPRAYED_ENTITIES_BY_DATE_LOAD_FAILED =
    'SPRAYED_ENTITIES_BY_DATE_LOAD_FAILED';
export const SPRAYED_ENTITIES_BY_DATE_LOAD_CANCELED =
    'SPRAYED_ENTITIES_BY_DATE_LOAD_CANCELED';
export const SPRAYED_ENTITIES_BY_DATE_SET = 'SPRAYED_ENTITIES_BY_DATE_SET';

export const SPRAYED_ENTITIES_BY_DATE_LOAD_NAMESPACE =
    'SPRAYED_ENTITIES_BY_DATE_LOAD';
